/* Anna Shehtova Photography — theme JS (no dependencies) */
(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* mobile menu */
  const openBtn = $('[data-menu-open]');
  const closeBtn = $('[data-menu-close]');
  const setMenu = (open) => document.body.classList.toggle('menu-open', open);
  openBtn && openBtn.addEventListener('click', () => setMenu(true));
  closeBtn && closeBtn.addEventListener('click', () => setMenu(false));
  $$('.sidebar .nav a').forEach((a) => a.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });

  /* hero crossfade slider */
  $$('[data-hero]').forEach((hero) => {
    const slides = $$('.hero__slide', hero);
    if (slides.length < 2) return;
    const dots = $$('.hero__dots button', hero);
    const interval = parseInt(hero.dataset.interval || '5500', 10);
    let i = 0, timer;
    const show = (n) => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
    };
    const start = () => { timer = setInterval(() => show(i + 1), interval); };
    dots.forEach((d, n) => d.addEventListener('click', () => { clearInterval(timer); show(n); start(); }));
    start();
  });

  /* project grid: sort by data-order, filter by category */
  $$('[data-project-grid]').forEach((wrap) => {
    const grid = $('.cards', wrap);
    const cards = $$('.card', grid).sort((a, b) => (+a.dataset.order || 999) - (+b.dataset.order || 999));
    cards.forEach((c) => grid.appendChild(c));
    const buttons = $$('.filters button', wrap);
    const apply = (cat) => {
      cards.forEach((c) => c.classList.toggle('is-hidden', cat !== 'all' && c.dataset.category !== cat));
      buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.filter === cat));
      if (history.replaceState) history.replaceState(null, '', cat === 'all' ? location.pathname : '#' + cat);
    };
    buttons.forEach((b) => b.addEventListener('click', () => apply(b.dataset.filter)));
    const initial = location.hash.replace('#', '');
    if (initial && buttons.some((b) => b.dataset.filter === initial)) apply(initial);
  });

  /* lazy image fade-in */
  const markLoaded = (img) => img.classList.add('is-loaded');
  $$('img[loading="lazy"]').forEach((img) => { if (img.complete) markLoaded(img); else img.addEventListener('load', () => markLoaded(img), { once: true }); });

  /* reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else { $$('.reveal').forEach((el) => el.classList.add('is-visible')); }

  /* hero mosaic: hover/focus expands, optional autoplay until interaction */
  $$('[data-mosaic]').forEach((m) => {
    const items = $$('[data-mosaic-item]', m);
    if (!items.length) return;
    let i = 0, timer = null;
    const activate = (n) => { items.forEach((it, k) => it.classList.toggle('is-active', k === n)); i = n; };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    items.forEach((it, n) => {
      it.addEventListener('mouseenter', () => { stop(); activate(n); });
      it.addEventListener('focus', () => { stop(); activate(n); });
      it.addEventListener('touchstart', () => activate(n), { passive: true });
    });
    if (m.dataset.autoplay === 'true' && matchMedia('(hover:hover)').matches) {
      timer = setInterval(() => activate((i + 1) % items.length), parseInt(m.dataset.interval || '4000', 10));
      m.addEventListener('mouseleave', () => { if (!timer) timer = setInterval(() => activate((i + 1) % items.length), parseInt(m.dataset.interval || '4000', 10)); });
    }
  });

  /* custom "View" cursor over gallery targets */
  const cur = $('.cursor');
  if (cur && matchMedia('(hover:hover) and (pointer:fine)').matches) {
    const label = $('.cursor__label', cur);
    let mx = -100, my = -100, cx = -100, cy = -100, raf;
    const tick = () => { cx += (mx - cx) * .18; cy += (my - cy) * .18; cur.style.transform = `translate(${cx}px,${cy}px) scale(${cur.classList.contains('is-on') ? 1 : .5})`; raf = requestAnimationFrame(tick); };
    document.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; if (!raf) tick(); }, { passive: true });
    document.addEventListener('mouseover', (e) => {
      const t = e.target.closest && e.target.closest('[data-cursor]');
      if (t) { label.textContent = t.dataset.cursor || 'View'; cur.classList.add('is-on'); document.body.classList.add('cursor-active'); }
      else { cur.classList.remove('is-on'); document.body.classList.remove('cursor-active'); }
    });
    document.addEventListener('mouseleave', () => cur.classList.remove('is-on'));
  }

  /* mark current nav link */
  const path = location.pathname.replace(/\/$/, '');
  $$('.nav a').forEach((a) => { const href = a.getAttribute('href').replace(/\/$/, ''); if (href && (href === path || (href !== '' && path.startsWith(href + '/')))) a.setAttribute('aria-current', 'page'); });
})();
